import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const TimePickerDisplay = styled.div<{ active?: boolean }>`
  width: 100%;
  height: 40px;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: 0.5s ease;
  padding: 0 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  ${(props) =>
    props.active &&
    `
      box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
      border: none;
      background-color: white;
    `}
`

export const TimePickerOptions = styled.div`
  position: absolute;
  top: 105%;
  left: 50%;
  transform: translateX(-50%);
  height: 300px;
  width: 100%;
  max-width: 200px;
  border-radius: 5px;
  display: flex;
  overflow: hidden;
  background: ${tokens.surface.raised};
  border: 1px solid ${tokens.border.hairline};
  box-shadow: ${tokens.shadow.card};
  z-index: 99;
`

export const TimePickerContainer = styled.div`
  width: 50%;
  max-height: 100%;
  overflow: scroll;
  padding: 0.2rem;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }
`

export const TimePickerTimeItem = styled.div<{ active?: boolean }>`
  width: 100%;
  aspect-ratio: 1.5;
  border-radius: 5px;
  transition: 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${(props) =>
    props.active &&
    `
    color: white;
    background-color: #ff9900;
  `}

  &::hover {
    color: white;
    background-color: #ff9900;
  }
`
